import React, {
  useCallback,
} from 'react'

import { useNavigate } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

import { Button } from '@termly/react-components'

import Paths from 'constants/paths'

import LogoHeader from 'components/Header/LogoHeader'
import MissingContent from 'components/MissingContent'

import Locale from './locale'
import Styles from './styles.scss'


export default function PageNotFoundPage() {
  const navigate = useNavigate()

  const handleButtonClick = useCallback(() => {
    navigate(Paths.ROOT)
  }, [navigate])

  return (
    <div className={ Styles.root }>
      <LogoHeader />

      <div className={ Styles.content }>
        <MissingContent
          caption="pageNotFoundCaption"
          logo="no-page"
          title="pageNotFoundTitle"
        >
          <Button
            className={ Styles.button }
            color="secondary"
            handleClick={ handleButtonClick }
          >
            <FormattedMessage
              { ...Locale.goHome }
            />
          </Button>
        </MissingContent>
      </div>
    </div>
  )
}

